import { User } from "shared/types/types";


const subjects: any = {
    modify: {
        text: "Modification de mon compte IDProtect",
        body: "Bonjour, Je souhaite modifier les informations de mon compte ID Protect.",
    },
    cancel: {
        text: "Résiliation de mon abonnement IDProtect",
        body: "Bonjour, Je souhaite résilier mon abonnement.",
    },
    buyCredits: {
        text: "Achat de vérifications IDProtect",
        body: "Bonjour, Je souhaite acheter des vérifications.",
    },
    verifyDocument: {
        text: "Informations sur la Vérification de document IDProtect",
        body: "Bonjour, Je souhaite avoir plus d'informations sur la vérification des documents.",
    },
    ParrainageIDProtect: {
        text: "Informations sur la Vérification de document IDProtect",
        body: "Bonjour, je vous parraine sur IDProtect. Voici mon code de parrainage: [code]",
    },
};

export const mailTo = (subject: string, user?: User | null) => {
    if (user?.email) {
        const userInfos = `\n-----------\n ${user?.firstname} ${user?.lastname} \n ${user?.email} \n ${user?.phoneNumber}`;
        const mail = "contact@idprotect.fr";
        window.location.href = `mailto:${mail}?subject=${subjects[subject].text}&body=${
            subjects[subject].body + encodeURIComponent(userInfos)
        }`;
    }else
    {
        const mail = "contact@idprotect.fr";
        window.location.href = `mailto:${mail}?subject=${subjects[subject].text}&body=${
            subjects[subject].body
        }`;
    }
};

export const extractEmailParam = (url: string): string | null => {
    try {
        // Trouver la partie après ?email= et avant le prochain & ou la fin
        const match = url.match(/[?&]email=([^&]*)/);
        return match ? match[1] : null;
    } catch {
        return null;
    }
};
